import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Footer.module.scss'

/**
 * The `Footer`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Footer = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.footer, styles.footer]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Footer.displayName = 'Footer'

/** @type {object} */
Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Footer.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Footer)
